import { Loading } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { getVerifyRegistration } from "../../../services/auth/auth.service";
import { getCustomerSubcampaignStatus } from "../../../services/ads/ads.service";
import { links } from "../../../constants/links";
import { useEffect, useState } from "react";

const VerifyToken = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = location.pathname.split("/")[2];
  const sessionId = localStorage.getItem("session-id");
  const [isLoading, setIsLoading] = useState(false);
  const subca = JSON.parse(atob(token));
  const subcampaignIdFromToken = subca["subcampaign_id"];

  useEffect(() => {
    setIsLoading(true);
    getVerifyRegistration({ data: token }).then((data) => {
      if (data && data["session-id"] && data["engage_session_id"]) {
        localStorage.setItem("session-id", data["session-id"]);
        localStorage.setItem("engage-session-id", data["engage_session_id"]);
        const subcampaign_id = data.subcampaign_id;
        const isGoogleForm = data.is_google_form;
        const isPayGetCoupon = data.is_pay_get_coupon;
        if (subcampaign_id) {
          localStorage.setItem("subcampaign_id", subcampaign_id);
          getCustomerSubcampaignStatus({ id: subcampaign_id }).then(statusData => {
            const is_session_expired: Boolean = statusData?.is_session_expired;
            const status: String = statusData?.status;
            if (!status || is_session_expired) {
              navigate(links.EARN_PAGE);
            } else {
              navigate(links.ENGAGE_PAGE.replace(":id", subcampaign_id), {
                state: {
                  isGoogleForm: isGoogleForm,
                  isPayGetCoupon: isPayGetCoupon,
                  status: status,
                  engage_session: data["engage_session_id"],
                  isFromVerifyToken: true,
                  channelSessionId: data["channel_session_id"],
                  isEngageGetCredit: data["is_engage_get_credit"],
                }
              });
            }
          }).catch((error) => {
            const msg = error?.response?.data?.error_msg;
            const advertiser_banner = error?.response?.data?.advertiser_banner;
            const banner_image_corner = error?.response?.data?.banner_image_corner;
            const engaged_subcampaign_id = error?.response?.data?.subcampaign_id;
            const last_engaged_session = error?.response?.data?.last_engaged_session;
            console.error("Error fetching customer subcampaign status", msg);
            if (msg === "CAMPAIGN_ALREADY_EXIST") {
              return navigate(links.ENGAGED_PAGE, {
                state: {
                  subcampaign_id: engaged_subcampaign_id,
                  advertiser_banner: advertiser_banner,
                  banner_image_corner,
                  last_engaged_session: last_engaged_session
                }
              });
            }
            else {
              navigate(links.EARN_PAGE);
            }
          });
        } else {
          navigate(links.EARN_PAGE);
        }
      } else {
        navigate(`${links.MAIN}?subcampaign_id=${subcampaignIdFromToken}`);
      }
    }).catch((error) => {

      const errorResponse = error?.response?.data;
      const background = errorResponse?.background;
      const banner_image_corner = errorResponse?.banner_image_corner;
      const errorCode = errorResponse?.error_code;

      if (errorCode === "engaged_limit_exceeded") {
        const limitEngageType = errorResponse?.limit_engage_type;
        return navigate(
          links.CAMPAIGN_LIMIT_ERROR,
          {
            state: {
              "advertiser_banner": background,
              "banner_image_corner": banner_image_corner,
              "limit_engage_type": limitEngageType
            }
          }
        );
      }
      else {
        navigate(`${links.MAIN}?subcampaign_id=${subcampaignIdFromToken}`);
      }
    }).finally(() => {
      setIsLoading(false);
    });
  }, [navigate, token]);

  return (
    <div>
      {
        isLoading && <Loading />
      }
    </div>
  );
};

export default VerifyToken;
